import { logger } from '@/lib/logger';

export interface CleanGeneratedPromptsOptions {
  // Prefixes the one warning about discarded entries, so the log names the surface that drew the set.
  label: string;
  maxCount: number;
  // An entry past it is a Beacon defect, not copy to clamp.
  maxLength: number;
}

// Beacon's set on the authored set's terms; null is no answer.
export function cleanGeneratedPrompts(
  prompts: readonly string[],
  { label, maxCount, maxLength }: CleanGeneratedPromptsOptions,
): string[] | null {
  const texts: string[] = [];
  const discarded: string[] = [];
  for (const entry of prompts) {
    const text = entry.trim();
    // Text is the identity: the wire carries no ids. Deduped before the cap, like authored ids.
    if (text.length === 0 || text.length > maxLength || texts.includes(text)) {
      discarded.push(entry);
      continue;
    }
    texts.push(text);
  }
  if (discarded.length > 0) {
    logger.warn(`${label}: discarding ${discarded.length} unusable generated prompts`, { discarded });
  }
  return texts.length === 0 ? null : texts.slice(0, maxCount);
}
